// @flow
import * as React from 'react';
import type { SvgComponentProps } from '~/core/icons/svg-icons/types';

const WelcomeHome = ({ fill, svgComponents: { G, Path } }: SvgComponentProps) => {
    const gProps = fill ? { fill } : {};
    return (
        <G {...gProps}>
            <Path d="M13,8.18472743 L13,31.8152726 C13,31.9084243 13.0981593,32 13.2617111,32 L15.7382889,32 C15.90219,32 16,31.907617 16,31.8152726 L16,8.18472743 C16,8.09157569 15.9018407,8 15.7382889,8 L13.2617111,8 C13.09781,8 13,8.09238303 13,8.18472743 Z M16,7.02504014 L16,4.99278641 C16,4.44448561 16.4321357,4.10803392 16.9634835,4.24087086 L27.0300251,6.75750627 C27.5657274,6.89143186 28,7.45127869 28,8.00329963 L28,31.9967004 C28,32.5508075 27.5729136,33.1067716 27.0382745,33.2404314 L16.9617255,35.7595686 C16.4305792,35.8923552 16,35.5476379 16,35.0072136 L16,32.9750924 C15.9157935,32.9914186 15.8282815,33 15.7382889,33 L13.2617111,33 C12.5648873,33 12,32.4806401 12,31.8152726 L12,8.18472743 C12,7.53042054 12.5541915,7 13.2617111,7 L15.7382889,7 C15.828022,7 15.9155672,7.00861247 16,7.02504014 Z M17,34.7192236 L26.7957388,32.2702889 C26.8817203,32.2487935 27,32.0955205 27,31.9967004 L27,8.00329963 C27,7.90863885 26.8765618,7.74991686 26.7874895,7.72764877 L17,5.28077641 L17,34.7192236 Z M19.5,23 C18.6715729,23 18,22.3284271 18,21.5 C18,20.6715729 18.6715729,20 19.5,20 C20.3284271,20 21,20.6715729 21,21.5 C21,22.3284271 20.3284271,23 19.5,23 Z" />
        </G>
    );
};

export default WelcomeHome;



// WEBPACK FOOTER //
// ./src/core/icons/svg-icons/general/welcome-home/index.js